import _ from 'lodash';
import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import ViewRailcarContainer from '../../containers/railcars/ViewRailcar';
import AuthUserContainer from '../../containers/AuthUser';

const styles = (theme) => ({
	sectionHeader: {
		margin: '30px 0px 10px 0px',
		textAlign: 'left',
		textTransform: 'uppercase',
		fontSize: 14,
		color: '#777',
		fontWeight: 900,
		letterSpacing: 2,
	},
	paper: {
		width: '100%',
		overflowX: 'auto',
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 20,
		[theme.breakpoints.up('md')]: {
			padding: '10px 40px 40px 40px',
		},
	},
	fieldLabel: {
		fontSize: 12,
		color: '#999',
		textTransform: 'uppercase',
		letterSpacing: 1,
		marginBottom: 2,
	},
	fieldValue: {
		fontSize: 15,
		color: '#333',
		marginBottom: 16,
	},
});

function Field({ classes, label, value }) {
	const display = value !== null && value !== undefined && value !== '' ? value : '—';
	return (
		<Grid item xs={12} md={6}>
			<div className={classes.fieldLabel}>{label}</div>
			<div className={classes.fieldValue}>{display}</div>
		</Grid>
	);
}

class ViewRailcar extends Component {
	componentDidMount() {
		const { railcarId, railcar, railcarGet } = this.props;
		if (!railcar) {
			railcarGet({ params: { railcarIds: [parseInt(railcarId, 10)] } });
		} else {
			this.fetchContractIfNeeded(this.props);
		}
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.railcar && this.props.railcar) {
			this.fetchContractIfNeeded(this.props);
		}
	}

	fetchContractIfNeeded(props) {
		const { railcar, fuelContract, fuelContractGet, isExternalReporting } = props;
		//- Contract data (pricing/terms) is employee-only; don't fetch or show it for externals
		if (isExternalReporting) {
			return;
		}
		if (railcar && railcar.fuelContractId && !fuelContract) {
			fuelContractGet({ params: { fuelContractIds: [railcar.fuelContractId] } });
		}
	}

	render() {
		const {
			classes,
			railcar,
			fuelContract,
			terminalMap,
			supplierMap,
			isExternalReporting,
		} = this.props;

		if (!railcar) {
			return <div>Fetching railcar information...</div>;
		}

		const terminal = terminalMap ? terminalMap[railcar.terminalId] : null;
		const supplier = supplierMap ? supplierMap[railcar.supplierId] : null;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Typography variant="h5" align="left" gutterBottom>
						Railcar {railcar.railcarNumber}
					</Typography>
				</Grid>

				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<div className={classes.sectionHeader}>Railcar Info</div>
						<Grid container>
							<Field classes={classes} label="Railcar Number" value={railcar.railcarNumber} />
							<Field classes={classes} label="BOL" value={railcar.bol} />
							<Field classes={classes} label="Product" value={railcar.product} />
							<Field classes={classes} label="Railroad" value={railcar.railroad} />
							<Field classes={classes} label="Fuel Supplier" value={railcar.fuelSupplier} />
							<Field classes={classes} label="Requested Month" value={railcar.requestedMonth} />
							<Field classes={classes} label="Net Gallons" value={railcar.netGallons} />
							<Field classes={classes} label="Gross Gallons" value={railcar.grossGallons} />
							<Field
								classes={classes}
								label="Requested Ship Date"
								value={railcar.requestedShipDate}
							/>
							<Field classes={classes} label="Actual Ship Date" value={railcar.actualShipDate} />
							<Field classes={classes} label="ETA Date" value={railcar.etaDate} />
							<Field classes={classes} label="CP Date" value={railcar.cpDate} />
							<Field classes={classes} label="AP Date" value={railcar.apDate} />
							<Field classes={classes} label="In Transit Days" value={railcar.inTransitDays} />
							<Field classes={classes} label="Empty Date" value={railcar.emptyDate} />
							<Field classes={classes} label="Relinquished Date" value={railcar.relinquishedDate} />
							<Field classes={classes} label="On Site Days" value={railcar.onSiteDays} />
							<Field classes={classes} label="Current Status" value={railcar.currentStatus} />
						</Grid>
					</Paper>
				</Grid>

				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<div className={classes.sectionHeader}>Terminal Info</div>
						{!terminal ? (
							<div style={{ color: '#999' }}>No terminal linked.</div>
						) : (
							<Grid container>
								<Field classes={classes} label="Terminal Name" value={terminal.name} />
								<Field classes={classes} label="Address" value={terminal.address} />
								<Field classes={classes} label="Contact Name" value={terminal.contactName} />
								<Field
									classes={classes}
									label="Contact Phone"
									value={terminal.contactPhoneNumber}
								/>
								<Field classes={classes} label="Notes" value={terminal.notes} />
							</Grid>
						)}
					</Paper>
				</Grid>

				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<div className={classes.sectionHeader}>Supplier Info</div>
						{!supplier ? (
							<div style={{ color: '#999' }}>No supplier linked.</div>
						) : (
							<Grid container>
								<Field classes={classes} label="Supplier Name" value={supplier.name} />
							</Grid>
						)}
					</Paper>
				</Grid>

				{!isExternalReporting && (
					<Grid item xs={12}>
						<Paper className={classes.paper}>
							<div className={classes.sectionHeader}>Contract Info</div>
							{!railcar.fuelContractId ? (
								<div style={{ color: '#999' }}>No contract linked to this railcar.</div>
							) : !fuelContract ? (
								<div>Fetching contract information...</div>
							) : (
								<Grid container>
									<Field
										classes={classes}
										label="Source Customer"
										value={fuelContract.sourceCustomer}
									/>
									<Field
										classes={classes}
										label="Contract Number"
										value={fuelContract.contractNumber}
									/>
									<Field
										classes={classes}
										label="Contract Loading Number"
										value={fuelContract.contractLoadingNumber}
									/>
									<Field classes={classes} label="Quarter" value={fuelContract.quarter} />
									<Field classes={classes} label="Product Type" value={fuelContract.productType} />
									<Field classes={classes} label="Start Date" value={fuelContract.startDate} />
									<Field classes={classes} label="End Date" value={fuelContract.endDate} />
									<Field classes={classes} label="Time Period" value={fuelContract.timePeriod} />
									<Field
										classes={classes}
										label="Number of Gallons"
										value={fuelContract.numberOfGallons}
									/>
									<Field
										classes={classes}
										label="Payment Terms"
										value={fuelContract.paymentTerms}
									/>
									<Field classes={classes} label="LCFS" value={fuelContract.lcfs} />
									<Field classes={classes} label="RINs" value={fuelContract.rins} />
									<Field
										classes={classes}
										label="Provisional Pricing"
										value={fuelContract.provisionalPricing}
									/>
									<Field
										classes={classes}
										label="Final Pricing"
										value={fuelContract.finalPricing}
									/>
								</Grid>
							)}
						</Paper>
					</Grid>
				)}
			</Grid>
		);
	}
}

export default _.flow([withStyles(styles), AuthUserContainer, ViewRailcarContainer])(ViewRailcar);
